import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { OptionValue } from '../../services/types/Misc';

interface Props {
  id?: string;
  headers: OptionValue[];
  tabSelected: number;
  setTabSelected: (value: number) => void;
}

const TabBar: React.FC<Props> = ({ id, tabSelected, setTabSelected, headers }) => {
  const toggle = (tabId: number) => {
    if (tabId !== tabSelected) {
      setTabSelected(tabId);
    }
  };

  const drawTab = (tab: OptionValue) => (
    <NavItem key={tab.id}>
      <NavLink
        id={tab.htmlId}
        className={classnames({ active: tabSelected === tab.id })}
        onClick={() => toggle(tab.id)}
      >
        {tab.text}
      </NavLink>
    </NavItem>
  );

  return (
    <div id={id} className="tabs tabs--bordered-bottom">
      <div className="tabs__wrap">
        <Nav tabs>{headers.map((tb) => drawTab(tb))}</Nav>
      </div>
    </div>
  );
};

export default React.memo(
  TabBar,
  (prevProps, nextProps) => prevProps.tabSelected === nextProps.tabSelected
);
